import { render, staticRenderFns } from "./AutomationDesignerDashboard.vue?vue&type=template&id=55acf4b0&scoped=true"
import script from "./AutomationDesignerDashboard.vue?vue&type=script&lang=js"
export * from "./AutomationDesignerDashboard.vue?vue&type=script&lang=js"
import style0 from "./AutomationDesignerDashboard.vue?vue&type=style&index=0&id=55acf4b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55acf4b0",
  null
  
)

export default component.exports